/*
	Language and currency picker behaviour: hover and click to open, dropdown
	repositioned onto <body> so it can escape the header's stacking context.

	This used to live in a {% javascript %} block inside sections/x-21e-v3-top-bar,
	which meant the picker only worked on pages where THAT section rendered. The
	markup is a shared snippet (header-localization-picker) but the code driving it
	was not, so rendering the picker anywhere else produced a dropdown that could
	not be opened at all. Moving it here, unchanged, lets x-21e-promo-bar host the
	same picker when it replaces the Trustpilot row.

	The guard below is because both sections can be enabled at once; a second copy
	would bind every listener twice and make the dropdown toggle against itself.
*/
if (!window.__21eLocalizationPickerLoaded) {
	window.__21eLocalizationPickerLoaded = true;


  (function() {
    'use strict';
    
    // Store original parent info for each dropdown
    const dropdownInfo = new WeakMap();
    
    // Position dropdown absolutely relative to picker container
    function positionDropdown(list, button) {
      if (!list || !button || list.hasAttribute('hidden')) return;
      
      // Store original parent if not already stored
      if (!dropdownInfo.has(list)) {
        dropdownInfo.set(list, {
          parent: list.parentElement,
          nextSibling: list.nextSibling
        });
      }
      
      // Hide dropdown initially to prevent flicker
      list.style.visibility = 'hidden';
      list.style.opacity = '0';
      
      // Move to body FIRST to escape header stacking context
      // This is critical for z-index to work above header
      if (list.parentElement !== document.body) {
        document.body.appendChild(list);
      }
      
      // Get button position in viewport
      const buttonRect = button.getBoundingClientRect();
      const dropdownWidth = 160; // 160px
      
      // Calculate centered position below the button
      const centerX = buttonRect.left + (buttonRect.width / 2);
      let left = centerX - (dropdownWidth / 2);
      
      // Clamp to viewport edges
      left = Math.max(8, Math.min(window.innerWidth - dropdownWidth - 8, left));
      const top = buttonRect.bottom + 8;
      
      // Get header z-index and set dropdown higher
      const rootStyle = getComputedStyle(document.documentElement);
      const headerZIndex = rootStyle.getPropertyValue('--header-z-index') || '10000000000000000000000';
      const dropdownZIndex = `calc(${headerZIndex.trim()} + 10)`;
      
      // Use absolute positioning relative to document (includes scroll offset)
      // This makes it scroll with page but appear above header
      const absoluteTop = top + window.scrollY;
      
      // Apply absolute positioning - relative to document, not viewport
      list.style.cssText = `
        position: absolute !important;
        top: ${absoluteTop}px !important;
        left: ${left}px !important;
        width: 160px !important;
        max-width: 160px !important;
        min-width: 160px !important;
        max-height: 200px !important;
        z-index: ${dropdownZIndex} !important;
        margin: 0 !important;
        padding: 8px 0 !important;
        transform: none !important;
        display: block !important;
        box-sizing: border-box !important;
        visibility: visible !important;
        opacity: 1 !important;
      `.trim();
      
      // Store initial position for debugging
      list.setAttribute('data-initial-top', absoluteTop.toString());
      list.setAttribute('data-initial-left', left.toString());
      
      // Verify it's actually fixed after a frame
      requestAnimationFrame(() => {
        const computed = window.getComputedStyle(list);
        const rect = list.getBoundingClientRect();
        
        if (computed.position !== 'fixed') {
          
          // Check for parent transforms
          let parent = list.parentElement;
          while (parent && parent !== document.body) {
            const parentStyle = window.getComputedStyle(parent);
            if (parentStyle.transform !== 'none' || 
                parentStyle.perspective !== 'none' || 
                parentStyle.willChange !== 'auto') {

            }
            parent = parent.parentElement;
          }
        }
      });
    }
    
    // Restore dropdown to original state
    function restoreDropdown(list) {
      if (!dropdownInfo.has(list)) return;
      
      const info = dropdownInfo.get(list);
      // Move back to original parent
      if (info.parent && list.parentElement === document.body) {
        if (info.nextSibling && info.nextSibling.parentElement === info.parent) {
          info.parent.insertBefore(list, info.nextSibling);
        } else {
          info.parent.appendChild(list);
        }
        list.style.cssText = '';
      }
    }
    
    // Close all other dropdowns except the one specified
    function closeOtherDropdowns(exceptListId) {
      console.log('🔴 [CloseOthers] Closing other dropdowns, keeping:', exceptListId);
      
      // Check all forms first (dropdowns in original location)
      document.querySelectorAll('.header-localization-picker localization-form').forEach(form => {
        const panel = form.querySelector('.disclosure__list');
        if (!panel) return;
        
        const isException = panel.id === exceptListId;
        const isHidden = panel.hasAttribute('hidden');
        
        console.log('🔴 [CloseOthers] Checking form panel:', {
          id: panel.id,
          isHidden: isHidden,
          isException: isException,
          shouldClose: !isException && !isHidden
        });
        
        // Close if it's not the exception AND it's not hidden (visible)
        if (!isException && !isHidden) {
          console.log('🔴 [CloseOthers] Closing form panel:', panel.id);
          
          if (form.hidePanel && typeof form.hidePanel === 'function') {
            console.log('🔴 [CloseOthers] Using form.hidePanel() for:', panel.id);
            form.hidePanel();
          } else {
            console.log('🔴 [CloseOthers] Fallback: setting hidden attribute for:', panel.id);
            panel.setAttribute('hidden', '');
          }
        }
      });
      
      // Also check any lists in body (moved dropdowns)
      const bodyLists = Array.from(document.body.children).filter(el => 
        el.id === 'HeaderCountryList' || el.id === 'HeaderLanguageList'
      );
      
      console.log('🔴 [CloseOthers] Found', bodyLists.length, 'panels in body');
      
      bodyLists.forEach(panel => {
        const isException = panel.id === exceptListId;
        const isHidden = panel.hasAttribute('hidden');
        
        console.log('🔴 [CloseOthers] Checking body panel:', {
          id: panel.id,
          isHidden: isHidden,
          isException: isException,
          shouldClose: !isException && !isHidden
        });
        
        if (!isException && !isHidden) {
          console.log('🔴 [CloseOthers] Closing body panel:', panel.id);
          panel.setAttribute('hidden', '');
          restoreDropdown(panel);
        }
      });
    }
    
    // Handle dropdown open/close
    function handleDropdownToggle(list) {
      const button = document.querySelector(`[aria-controls="${list.id}"]`);
      if (!button) {
        return;
      }
      
      const isHidden = list.hasAttribute('hidden');
      
      if (isHidden) {
        restoreDropdown(list);
          } else {            
            // Close other dropdowns IMMEDIATELY when this one opens
            closeOtherDropdowns(list.id);
            
            // Position immediately without delay to prevent flicker
            // Use requestAnimationFrame to ensure DOM is ready but do it synchronously
            requestAnimationFrame(() => {
              positionDropdown(list, button);
            });
          }
    }
    
    // Track which dropdowns were opened via click (persistent) vs hover (temporary)
    const clickOpenedDropdowns = new Set();
    const hoverTimeouts = new Map();
    
    // Initialize
    function init() {
      // Add hover handlers to header picker buttons
      document.querySelectorAll('.header-localization-picker__button').forEach(button => {
        const form = button.closest('localization-form');
        if (!form) return;
        
        const listId = button.getAttribute('aria-controls');
        if (!listId) return;
        
        // Track mouse position
        let isMouseOverButton = false;
        let isMouseOverList = false;
        
        // Hover to open - same as click (but only if not click-opened)
        button.addEventListener('mouseenter', () => {
          isMouseOverButton = true;
          
          // Only open on hover if not click-opened
          if (!clickOpenedDropdowns.has(listId)) {
            const list = document.getElementById(listId);
            if (list && list.hasAttribute('hidden')) {
              // Call the same function that click uses
              if (form.openSelector) {
                form.openSelector();
              }
            }
          }
        });
        
        // Hover to close - same as click (but only if not click-opened)
        button.addEventListener('mouseleave', () => {
          isMouseOverButton = false;
          
          // Only close on unhover if not click-opened and not moving to list
          if (!clickOpenedDropdowns.has(listId) && !isMouseOverList) {
            // Use small delay to allow moving to list
            if (hoverTimeouts.has(listId)) {
              clearTimeout(hoverTimeouts.get(listId));
            }
            
            const timeout = setTimeout(() => {
              if (!isMouseOverList && !clickOpenedDropdowns.has(listId)) {
                // Call the same function that click uses to close
                if (form.hidePanel) {
                  form.hidePanel();
                }
              }
              hoverTimeouts.delete(listId);
            }, 100);
            hoverTimeouts.set(listId, timeout);
          }
        });
        
        // Handle hover on list itself
        const setupListHandlers = (list) => {
          if (!list) return;
          
          list.addEventListener('mouseenter', () => {
            isMouseOverList = true;
            // Clear close timeout (only if not click-opened)
            if (!clickOpenedDropdowns.has(listId)) {
              if (hoverTimeouts.has(listId)) {
                clearTimeout(hoverTimeouts.get(listId));
                hoverTimeouts.delete(listId);
              }
            }
          });
          
          list.addEventListener('mouseleave', () => {
            isMouseOverList = false;
            // Close if not moving to button and not click-opened
            if (!isMouseOverButton && !clickOpenedDropdowns.has(listId)) {
              // Call the same function that click uses to close
              if (form.hidePanel) {
                form.hidePanel();
              }
            }
          });
        };
        
        // Set up handlers for initial list
        const list = document.getElementById(listId);
        if (list) {
          setupListHandlers(list);
        }
        
        // Watch for when list is moved to body
        const parentObserver = new MutationObserver(() => {
          const currentList = document.getElementById(listId);
          if (currentList && currentList.parentElement === document.body) {
            setupListHandlers(currentList);
          }
        });
        parentObserver.observe(document.body, { childList: true });
        
        // Click handler - mark as persistent (perma open)
        button.addEventListener('click', () => {
          // Wait for LocalizationForm to toggle, then mark as click-opened
          setTimeout(() => {
            const list = document.getElementById(listId);
            if (!list) return;
            
            if (list.hasAttribute('hidden')) {
              // Was closed - remove from click-opened set (hover can work again)
              clickOpenedDropdowns.delete(listId);
            } else {
              // Was opened - mark as click-opened (persistent, hover won't close it)
              clickOpenedDropdowns.add(listId);
            }
          }, 10);
        });
      });
      
      // Watch for dropdown open/close via hidden attribute
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
            const list = mutation.target;
            // Check if it's one of our header picker dropdowns
            // Either in the picker container OR moved to body
            const isHeaderPickerList = (list.id === 'HeaderCountryList' || list.id === 'HeaderLanguageList') &&
                                      list.classList.contains('disclosure__list');
            const isInPicker = list.closest('.header-localization-picker');
            const isInBody = list.parentElement === document.body;
            
            // Handle if it's our dropdown (in picker OR moved to body)
            if (isHeaderPickerList && (isInPicker || isInBody)) {
              handleDropdownToggle(list);
            }
          }
        }
      });
      
      // Observe all dropdown lists (both in picker and any that get moved to body)
      const observeList = (list) => {
        if (list && (list.id === 'HeaderCountryList' || list.id === 'HeaderLanguageList')) {
          observer.observe(list, { attributes: true, attributeFilter: ['hidden'] });
        }
      };
      
      // Observe initial lists
      document.querySelectorAll('.header-localization-picker .disclosure__list').forEach(observeList);
      
      // Also observe any lists in body (in case they're already there)
      Array.from(document.body.children).forEach(el => {
        if (el.id === 'HeaderCountryList' || el.id === 'HeaderLanguageList') {
          observeList(el);
        }
      });
      
      // Watch for new lists being added to body
      const bodyObserver = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && (node.id === 'HeaderCountryList' || node.id === 'HeaderLanguageList')) {
              observeList(node);
            }
          });
        });
      });
      bodyObserver.observe(document.body, { childList: true });
      
      // Track dropdown position during scroll
      let positionTracker = null;
      
      // Close hover-opened dropdowns on scroll (keep click-opened ones)
      window.addEventListener('scroll', () => {
        document.querySelectorAll('.header-localization-picker .disclosure__list:not([hidden])').forEach(list => {
          const listId = list.id;
          // Only close if it wasn't opened via click
          if (!clickOpenedDropdowns.has(listId)) {
            const form = list.closest('localization-form');
            if (form && form.hidePanel) {
              form.hidePanel();
            }
          }
        });
      }, { passive: true, capture: true });
      
      // Handle resize
      window.addEventListener('resize', () => {
        document.querySelectorAll('.header-localization-picker .disclosure__list:not([hidden])').forEach(list => {
          const button = document.querySelector(`[aria-controls="${list.id}"]`);
          if (button && list.parentElement === document.body) {
            positionDropdown(list, button);
          }
        });
      });
      
    }
    
    // Start when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    
    // Also try after a delay for dynamically loaded content
    setTimeout(init, 100);
  })();
}
